import { useEffect, useState } from "react";
import {
  CONSENT_EVENT,
  ConsentCategory,
  ConsentState,
  readConsent,
  writeConsent,
} from "@/lib/consent";

/**
 * Reactive consent hook.
 * Re-renders any component when consent changes (banner accept, footer toggle, etc.).
 */
export function useConsent() {
  const [state, setState] = useState<ConsentState>(() => readConsent());

  useEffect(() => {
    const handler = () => setState(readConsent());
    window.addEventListener(CONSENT_EVENT, handler);
    // Cross-tab sync
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener(CONSENT_EVENT, handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  return {
    state,
    has: (cat: ConsentCategory) => state[cat] === true,
    setCategory: (cat: Exclude<ConsentCategory, "essential">, value: boolean) =>
      writeConsent({ [cat]: value } as Partial<ConsentState>),
    acceptAll: () => writeConsent({ analytics: true, marketing: true }),
    acceptEssentialOnly: () => writeConsent({ analytics: false, marketing: false }),
  };
}
